export default __webpack_public_path__ + "static/media/0xe82808eaa78339b06a691fd92e1be79671cad8d3.a4767f49.png";